/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { forwardRef } from 'react';

import { PasswordField } from '@coursera/cds-core';
import type { PasswordFieldProps } from '@coursera/cds-core';

import { commonStyles } from 'bundles/authentication-common/components/commonStyles';

import _t from 'i18n!nls/authentication';

type OwnProps = {
  label?: string;
  name?: string;
  placeholder?: string;
  'data-e2e'?: string;
  autoComplete?: 'new-password' | 'current-password';
  supportText?: React.ReactNode;
  hint?: React.ReactNode;
};

type Props = OwnProps &
  Omit<PasswordFieldProps, keyof OwnProps | 'type'> & {
    value?: string | number;
    defaultValue?: string | number;
    validationStatus?: 'error' | 'success';
    validationLabel?: string;
  };

const PasswordInput = forwardRef<HTMLInputElement, Props>(
  (
    {
      label = _t('Password'),
      name = 'password',
      placeholder = _t('Create password'),
      autoComplete = 'current-password',
      supportText,
      validationLabel,
      validationStatus,
      ...props
    },
    ref
  ) => (
    <div>
      <PasswordField
        inputProps={{ 'data-e2e': props?.['data-e2e'] }}
        fullWidth
        label={label}
        name={name}
        placeholder={placeholder}
        ref={ref}
        autoComplete={autoComplete}
        supportText={supportText}
        necessityIndicator="icon"
        {...{ ...props, 'data-e2e': undefined }}
        {...(validationLabel ? { validationLabel, validationStatus } : {})}
      />
      {props?.hint && <div css={commonStyles.hint}>{props?.hint}</div>}
    </div>
  )
);
export default PasswordInput;
